import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './AuthForm.css'; // ✅ Import the CSS

export default function AuthForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    let error;

    if (isLogin) {
      const { error: loginError, data: loginData } =
        await supabase.auth.signInWithPassword({ email, password });
      error = loginError;
      if (loginData?.session) {
        navigate('/dashboard');
      }
    } else {
      const { error: signupError } = await supabase.auth.signUp({ email, password });
      error = signupError;
      alert('Signup successful! Check your email to confirm.');
    }

    if (error) alert(error.message);
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2 className="auth-title">Log In</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
}